import React, { useContext, useRef, useState } from "react";

import ItemCard from "../../components/item-card/ItemCardController.jsx";
import { GlobalContext } from "../../globals/globalContext.jsx";
import { currencyFormat } from "../../util/i18n.js";
import ItemOptionsModal from "../../components/item-options-modal/ItemOptionModal.jsx";
import { post } from "../../util/fetch.js";
import "./styles.styl";
import { useIntl } from "react-intl";

const excludedClasses = [
  "catalog-grid-item__edit-qts-plus-unable",
  "catalog-grid-item__edit-qts-minus",
  "catalog-grid-item__edit-qts-plus",
  "catalog-grid-item__edit-qts-add",
  "catalog-grid-item__edit-qts-num_in_cart",
  "catalog-opened-grid-item__edit-qts-add",
  "catalog-grid-item__uneditable-qts-plus",
  "catalog-grid-item__uneditable-qts-num",
  "catalog-grid-item__uneditable-qts-minus",
  "catalog-grid-item__uneditable-qts-num_in_cart",
  "catalog-item__edit-qts-plus",
  "catalog-item__edit-qts-num",
  "catalog-item__edit-qts-minus",
  "catalog-item__edit-qts-add",
];

export default function CatalogItem(props) {
  const [atEnd, setAtEnd] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const {
    logoSmallUrl,
    colorSecondary,
    windowWidth,
    onFavouriteAddRemove,
    ruleCount,
    setRuleCount,
    subscription,
  } = useContext(GlobalContext);
  const cardRef = useRef(null);
  const isDesktop = windowWidth > 940;
  const intl = useIntl();

  const { item, editable, allow_ordering_before_suggestions_at, isPacked } =
    props;
  const deliver_listing = item.deliver_listing ? item.deliver_listing : item;
  const {
    id,
    sale_price_pro_sale_unit,
    sale_price_pro_bu,
    show_stk_unit_in_frontend,
    article,
    sales_unit_display,
    sales_package_weight,
    display_inactive,
    deposit_price,
  } = deliver_listing;
  const producer = article.producer;
  const product_details = article.nutrition_product_details;

  const isAtLeastOneNutrition = product_details
    ? Object.entries(product_details).map(([key, value]) => {
        if (
          key !== "description" &&
          key !== "producer_info" &&
          key !== "product_info" &&
          key !== "storage_info" &&
          key !== "usage_info" &&
          key !== "description" &&
          value
        ) {
          return true;
        }
        return false;
      })
    : false;

  const incl_deposit = deposit_price
    ? "+" +
      currencyFormat(deposit_price) +
      "€ " +
      intl.formatMessage({ id: "deposit_lc" })
    : null;
  const { product_unit, base_unit } = deliver_listing.article.sku;
  const base_price_display = base_unit
    ? currencyFormat(sale_price_pro_bu) + "€/" + base_unit.name
    : currencyFormat(sale_price_pro_bu) + "€/" + product_unit.base_unit.name;
  const unit_to_render = base_unit
    ? base_unit.measure
    : product_unit.base_unit.measure;
  const nahrwerte_string = ["piece", "weight"].includes(unit_to_render)
    ? intl.formatMessage({ id: "nutritionG" })
    : intl.formatMessage({ id: "nutritionML" });
  const stk = show_stk_unit_in_frontend
    ? intl.formatMessage({ id: "pieceCa" })
    : "";
  const producer_display = producer ? producer : "";

  function handleDestCollapsible(detailType) {
    const detailId = detailType + id;
    if (detailId === props.openedId) {
      props.handleClick(null);
    } else {
      props.handleClick(detailId);
    }
  }

  function handleNutritionalCollapsible() {
    if (id === props.openedId) {
      props.handleClick("close" + id);
    } else {
      props.handleClick(id);
    }
  }

  function handleAddClick(e) {
    e.stopPropagation();
    const { item } = props;
    const subscriptionIsAutobuy = subscription?.auto_buy || false;
    if (
      !item.rule &&
      !props.ownerlessShop &&
      (item.default_recurrence || (!subscriptionIsAutobuy && ruleCount > 0))
    ) {
      setIsModalOpen(true);
    } else {
      const patch = { id: null, deliver_listing: item, action: 1 };
      props.onChange(patch);
    }
  }

  function handleConfirmModal(ruleProductData) {
    const { item } = props;

    const patch = {
      id: null,
      deliver_listing: item,
      action: ruleProductData.amount,
    };
    if (ruleProductData.periodicity === "ONCE") {
      props.onChange(patch);
      setIsModalOpen(false);
    } else {
      const requestData = {
        ...ruleProductData,
        temporary_amount: ruleProductData.amount,
        amount: null,
      };

      delete requestData.is_temporary;
      post("/api/rule-product/", { body: requestData }).then(
        (response) => {
          props.onChange(patch);
          if (
            response.mode === "subscribe" &&
            response.is_temporary &&
            response.temporary_amount >= 1
          ) {
            setRuleCount((prevCount) => prevCount + 1);
          }
          setIsModalOpen(false);
        },
        (error) => {
          console.error(error);
        },
      );
    }
  }

  function handleIncrementClick(e) {
    e.stopPropagation();
    const item = props.getMatchedItemFromCart(
      props.item.matched_cart_item_id,
    )[0];
    const action = 1;
    const patch = { ...item, action };
    props.onChange(patch);
  }

  function handleDecrementClick(e) {
    e.stopPropagation();
    const item = props.getMatchedItemFromCart(
      props.item.matched_cart_item_id,
    )[0];

    if (!item) {
      return;
    }
    const action = -1;
    const patch = { ...item, action };
    props.onChange(patch);
  }

  function handleDropdownQuantityChange(e, amount) {
    e.stopPropagation();
    const item = props.getMatchedItemFromCart(
      props.item.matched_cart_item_id,
    )[0];

    if (!item) {
      return;
    }
    const action = amount;
    const patch = { ...item, action };
    props.onChange(patch);
  }

  function toggleGridEditVisible(event) {
    props.handleClick(null);
    isCardAtEnd();
    if (excludedClasses.includes(event.target.className)) {
      return;
    }
    if (props.sold) {
      return;
    }
    if (props.visibleItemId === props.productId) {
      return props.handleVisibleItem(null);
    }
    return props.handleVisibleItem(props.productId);
  }

  const isCardAtEnd = () => {
    if (cardRef.current && props.listRef.current) {
      const cardRect = cardRef.current.getBoundingClientRect();
      const containerRect = props.listRef.current.getBoundingClientRect();
      const isAtEndOfRow =
        containerRect.right - cardRect.right < cardRect.width;
      setAtEnd(isAtEndOfRow);
    }
  };

  function toggleEditVisible(event) {
    props.handleClick(null);
    if (excludedClasses.includes(event.target.className)) {
      return;
    }
    if (props.visibleItemId === props.productId) {
      return props.handleVisibleItem(null);
    }
    if (props.sold) return;
    return props.handleVisibleItem(props.productId);
  }

  const isListCard = props.isGrid || isDesktop;

  return (
    <>
      {isModalOpen && (
        <ItemOptionsModal
          deliver_listing={props.item}
          delivery={props.delivery}
          onClose={() => setIsModalOpen(false)}
          onConfirm={handleConfirmModal}
          fromCatalog={true}
        />
      )}
      <ItemCard
        onItemAddRemove={props.onItemAddRemove}
        ownerlessShop={props.ownerlessShop}
        name={props.name}
        categoryId={props.categoryId}
        editable={editable && !isPacked}
        article_name_without_qualities={article.name}
        article_quality={article._qualities}
        display_inactive={display_inactive}
        base_price_display={base_price_display}
        container_contents={deliver_listing.container_contents}
        colorSecondary={colorSecondary}
        customToggleEditVisible={
          isListCard ? toggleGridEditVisible : toggleEditVisible
        }
        cardRef={cardRef}
        allow_ordering_before_suggestions_at={
          allow_ordering_before_suggestions_at
        }
        handleAddClick={handleAddClick}
        handleDecrementClick={handleDecrementClick}
        handleDropdownQuantityChange={handleDropdownQuantityChange}
        handleDestCollapsible={handleDestCollapsible}
        handleIncrementClick={handleIncrementClick}
        handleNutritionalCollapsible={handleNutritionalCollapsible}
        id={id}
        incl_deposit={incl_deposit}
        index={props.index}
        isAtEndOfRow={atEnd}
        isAtLeastOneNutrition={isAtLeastOneNutrition}
        isDesktop={isDesktop}
        isItemOpen={props.isItemOpen}
        isFavourite={item.is_favourite}
        latestRow={props.latestRow}
        listRef={props.listRef}
        cardWrapperRef={props.listRef}
        logoSmallUrl={logoSmallUrl}
        nahrwerte_string={nahrwerte_string}
        num_portions_in_cart={props.showQtInCatalog}
        openedId={props.openedId}
        position="catalog"
        producer_display={producer_display}
        product_details={product_details}
        product_image={article?.image}
        sale_price_pro_bu={sale_price_pro_bu}
        sale_price_pro_sale_unit={sale_price_pro_sale_unit}
        sales_package_weight={sales_package_weight}
        sales_unit_display={sales_unit_display}
        setLatestRow={props.setLatestRow}
        stk={stk}
        subscriptionId={props.delivery?.subscription?.id}
        article_name={isListCard ? undefined : article.name}
        isListCard={!isListCard}
        onFavouriteAddRemove={onFavouriteAddRemove}
      />
    </>
  );
}
